<template>
  <div class="editPin">
    <div class="editPin__intro u-ta-center">
      <button
        id="dcNew"
        class="btn btn--primary"
        @click="openForm()"
        v-show="!editPinOpen"
      >
        Upravit pracovní pin <strong>{{ pinId }}</strong>
      </button>
    </div>

    <div>
      <br />
      <div class="btns">
        <div
          v-for="(line, index) in Object.values(lines)"
          :key="line.id"
          class="drawingManager__Btn btnStyled btnWrapper"
        >
          <div class="verticalCenter">
            <i v-if="isDrawingMode && line.id === currentLine.id"
              >Délka: {{ currentLineLength }}m</i
            >
            <strong v-else>Oblast {{ index + 1 }} </strong>
          </div>

          <button
            @click="finishLine()"
            class="sideButton support"
            v-if="isDrawingMode && line.id === currentLine.id"
          >
            <i class="fas fa-check"></i> Dokončit
          </button>
          <button @click="editLine(line.id)" class="sideButton" v-else>
            <i class="fas fa-edit"></i> Upravit
          </button>
          <button @click="deleteLine(line.id)" class="sideButton">
            <i class="far fa-trash-alt"></i> Smazat
          </button>
        </div>

        <button
          @click="startLine()"
          class="drawingManager__Btn btnStyled edit"
          v-show="!isDrawingMode"
        >
          <i class="fas fa-plus-circle"></i> Zakreslit oblast zájmu
        </button>

        <div
          v-show="
            isDrawingMode &&
            lines[currentLine.id] === undefined &&
            currentLine.getPath().length === 0
          "
          class="drawingManager__Btn btnStyled btnWrapper"
        >
          <div class="verticalCenter">
            <i>Kliknutím do mapy začnete kreslit</i>
          </div>

          <button @click="cancelLine()" class="sideButton">
            Zrušit
          </button>
        </div>

        <div
          v-show="
            isDrawingMode &&
            lines[currentLine.id] === undefined &&
            currentLine.getPath().length > 0
          "
          class="drawingManager__Btn btnStyled btnWrapper"
        >
          <div class="verticalCenter">
            <i>Délka: {{ currentLineLength }}m</i>
          </div>

          <button @click="finishLine()" class="sideButton support">
            <i class="fas fa-check"></i> Ukončit kreslení a uložit
          </button>

          <button @click="cancelLine()" class="sideButton">
            Zrušit
          </button>
        </div>
      </div>

      <form
        @submit="sendForm"
        method="post"
        class="form-horizontal"
        id="frm-drawingPinForm"
      >
        <input type="hidden" name="lat" id="dcLat" value="" v-model="lat" />
        <input type="hidden" name="lng" id="dcLng" value="" v-model="lng" />
        <br />
        <div class="form-control">
          <label for="frm-drawingPinForm-text">Název pinu</label>
          <input
            type="text"
            name="name"
            class="form-control"
            id="frm-drawingPinForm-name"
            v-model="title"
            required
          />
        </div>
        <div class="form-control">
          <label for="frm-drawingPinForm-text">Popis pinu</label>
          <textarea
            name="description"
            class="form-control"
            id="frm-drawingPinForm-description"
            v-model="text"
            required
          ></textarea>
        </div>
        <div class="form-control">
          <label for="frm-drawingPinForm-detail">Detail pinu</label>
          <textarea
            name="detail"
            class="form-control"
            id="frm-drawingPinForm-detail"
            v-model="text_detail"
            required
          ></textarea>
        </div>

        <div v-if="this.threads.markersLayered[this.pinId].image">
          <strong>Obrázek pinu</strong>
          <div class="pictureWrapper">
            <div :class="{ strikeText: deletePicture }">
              {{ this.threads.markersLayered[this.pinId].image }}
            </div>

            <button
              @click="setDeletePicture($event)"
              class="pictureButton"
              v-show="!deletePicture"
            >
              <i class="far fa-trash-alt"></i> Smazat
            </button>
            <button
              @click="setRestorePicture($event)"
              class="pictureButton"
              v-show="deletePicture"
            >
              <i class="fas fa-trash-restore"></i> Obnovit
            </button>
          </div>
        </div>
        <div v-if="this.threads.markersLayered[this.pinId].attachments">
          <strong>Přílohy</strong>
          <div
            v-for="attachment in this.threads.markersLayered[this.pinId]
              .attachments"
            :key="attachment.fileName"
            class="pictureWrapper"
          >
            <div
              :class="{
                strikeText: deleteAttachments.find(
                  (att) => att.id === attachment.id
                )
              }"
            >
              {{ attachment.fileName || attachment.name }}
            </div>
            <button
              @click="setDeleteAttachment($event, attachment)"
              class="pictureButton"
              v-show="
                !deleteAttachments.find((att) => att.id === attachment.id)
              "
            >
              <i class="far fa-trash-alt"></i> Smazat
            </button>
            <button
              @click="setRestoreAttachment($event, attachment)"
              class="pictureButton"
              v-show="deleteAttachments.find((att) => att.id === attachment.id)"
            >
              <i class="fas fa-trash-restore"></i> Obnovit
            </button>
          </div>
        </div>
        <div class="form-control">
          <label for="frm-drawingPinForm-picture"
            >Nový obrázek ( nahradí starý )</label
          >
          <br />
          <input
            type="file"
            name="picture"
            class="form-control"
            id="frm-drawingPinForm-picture"
            @change="picture = $event.target.files"
            accept="image/*"
          />
        </div>
        <div class="form-control">
          <label for="frm-drawingPinForm-attachments">Nové přílohy</label>
          <br />
          <div class="fileUploadWrapper">
            <input
              type="file"
              name="attachments"
              class="form-control"
              id="frm-drawingPinForm-attachments"
              ref="attachments"
              @change="validateAttachments($event)"
              files
              multiple
            />
            <button
              @click="clearUploads($event)"
              class="pictureButton"
              v-show="attachments.length > 0"
              title="Smazat všechny nahrané"
            >
              <i class="far fa-trash-alt"></i>
            </button>
          </div>
        </div>
        <br />
        <WizardEventDispatcher :event="'click'" :target="'button-save-pin'">
          <input
            type="submit"
            class="btn btn-primary"
            value="Uložit pin"
          />
        </WizardEventDispatcher>
      </form>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import PinService from '@/services/PinService';
import { clonePolyline } from '@/utils/helpers.js';
import WizardEventDispatcher from '@/components/wizard/WizardEventDispatcher.vue';

export default {
  components: {
    WizardEventDispatcher
  },
  data() {
    return {
      pinId: null,
      drawingId: null,
      lat: null,
      lng: null,
      title: null,
      text: null,
      text_detail: null,
      line: null,
      attachments: [],
      picture: null,
      editPinOpen: true,
      polylineStarted: false,
      editing: false,
      deletePicture: false,
      deleteAttachments: []
    };
  },
  created() {
    if (this.general.editPinId) {
      this.pinId = this.general.editPinId;

      const pin = this.threads.markersLayered[this.pinId];

      console.log(pin);

      if (pin) {
        this.drawingId = pin.drawingId;
        this.lat = pin.lat;
        this.lng = pin.lng;
        this.title = pin.title;
        this.text = pin.text;
        this.text_detail = pin.text_detail;
        this.line = pin.line;
        // this.attachments = pin.attachments
        // this.picture = pin.picture

        if (pin.lines) {
          this.$store.dispatch('general/setDrawingLines', { lines: pin.lines });
        }
      }
    }
  },
  methods: {
    clearUploads(event) {
      event.preventDefault();
      this.$refs.attachments.value = '';
      this.attachments = [];
    },
    setDeleteAttachment(event, attachment) {
      event.preventDefault();
      this.deleteAttachments.push(attachment);
      console.log(this.deleteAttachments);
    },
    setRestoreAttachment(event, attachment) {
      event.preventDefault();
      /*const attachmentsUploadedCount = this.threads.markersLayered[this.pinId]
        .attachments
        ? this.threads.markersLayered[this.pinId].attachments.length -
          this.deleteAttachments.length +
          this.attachments.length +
          1
        : 0;

      if (attachmentsUploadedCount >= 3) {
        this.$toasted.show(
          'Maximální počet příloh je 3. Pro nahrání dalších smažte již nahrané.',
          {
            type: 'error',
            position: 'bottom-left',
            duration: '5000'
          }
        );
      } else {*/
      this.deleteAttachments.splice(
        this.deleteAttachments.findIndex((a) => a.id === attachment.id),
        1
      );
      //}
    },
    setDeletePicture(event) {
      event.preventDefault();
      this.deletePicture = true;
    },
    setRestorePicture(event) {
      event.preventDefault();
      this.deletePicture = false;
    },
    editLine(id) {
      if (!this.isDrawingMode) {
        this.$store.dispatch('general/startDrawingLine', { id });
      }
    },
    cancelLine() {
      this.$store.dispatch('general/cancelDrawingLine');
    },
    finishLine() {
      this.$store.dispatch('general/finishDrawingLine');
    },
    startLine() {
      this.$store.dispatch('general/startDrawingLine');
    },
    deleteLine(id) {
      if (!this.isDrawingMode) {
        this.$store.dispatch('general/deleteLine', { id });
      }
    },
    validateAttachments(event) {
      /*const attachmentsUploadedCount = this.threads.markersLayered[this.pinId]
        .attachments
        ? this.threads.markersLayered[this.pinId].attachments.length -
          this.deleteAttachments.length
        : 0;
      if (event && event.target.files.length + attachmentsUploadedCount > 3) {
        this.$toasted.show(
          'Maximální počet příloh je 3. Pro nahrání dalších smažte již nahrané.',
          {
            type: 'error',
            position: 'bottom-left',
            duration: '5000'
          }
        );
        this.$refs.attachments.value = '';
      }
      console.log('this.$refs', this.$refs);*/

      this.attachments = event.target.files;
    },
    openForm() {
      this.editPinOpen = true;
    },
    closeForm() {
      this.editPinOpen = false;
    },
    sendForm(e) {
      e.preventDefault();

      const lines = this.general.pin.lines;
      const attachments = this.general.pin.attachments || [];
      const linePaths = Object.values(lines).reduce((acc, line, index) => {
        acc[index] = line
          .getPath()
          .getArray()
          .map((l) => ({
            lat: l.lat(),
            lng: l.lng()
          }));
        return acc;
      }, {});

      const data = {
        lat: this.lat,
        lng: this.lng,
        title: this.title,
        text: this.text,
        text_detail: this.text_detail,
        line: linePaths
      };
      const gmaps = this.gmaps;

      const files = [];
      PinService.editPin(this.pinId, this.drawingId, data)
        .then((response) => {
          if (this.attachments.length > 0) {
            this.attachments.forEach((file) => {
              const formdata = new FormData();
              files.push(file);
              formdata.append('file', file);

              PinService.addAttachments(
                this.pinId,
                this.drawingId,
                formdata
              ).catch(() => {});
            });
          }

          if (this.deleteAttachments.length > 0) {
            this.deleteAttachments.map((att) => {
              PinService.deleteAttachment(
                this.pinId,
                this.drawingId,
                att.id
              ).catch(() => {});
            });
          }

          if (this.deletePicture) {
            PinService.deletePhoto(this.pinId, this.drawingId).catch(() => {});
          }

          if (this.picture) {
            const image = new FormData();

            image.append('file', this.picture[0]);

            PinService.addPhoto(
              this.pinId,
              this.drawingId,
              image
            ).catch(() => {});
          }

          const newLines = Object.values(lines).map(function (line, index) {
            return clonePolyline(gmaps, line);
          });

          this.$store.dispatch('threads/updateMarker', {
            ...data,
            ...{
              attachments:
                files.length > 0 ? [...attachments, ...files] : undefined
            },
            ...{ picture: this.picture ? this.picture.name : undefined },
            id: this.general.editPinId,
            lines: newLines
          });

          this.$store.dispatch('general/clearPreviousLines');
          this.$store.dispatch('general/setNewPinPhase', null);

          this.$store.dispatch('general/setLayoutOption', ['editPin', false]);
          this.$store.dispatch('general/clearEditPinId');

          this.general.infowindow.close();

          this.$toasted.show('Hotovo.', {
            type: 'success',
            position: 'top-right',
            duration: '5000'
          });
        })
        .catch((e) => console.error(e));
    }
  },
  computed: {
    ...mapState(['general', 'threads', 'gmaps']),
    isDrawingMode() {
      return !!this.general.pin.activeLine;
    },
    currentLine() {
      return this.general.pin.activeLine;
    },
    currentLineLength() {
      if (this.currentLine) {
        const path = this.currentLine.getPath();

        if (path.length > 1) {
          return parseFloat(
            this.gmaps.google.maps.geometry.spherical.computeLength(path)
          ).toFixed(1);
        }

        return 0;
      }
      return 0;
    },
    lines() {
      return this.general.pin.lines;
    }
  }
};
</script>
<style scoped>
input[name='name'] {
  padding: 10px;
  width: 100%;
}
input[type='file'] {
  max-width: 75%;
}
.drawingManager__Btn {
  margin-top: 10px;
  background: whitesmoke;
  padding: 15px;
  box-shadow: 0 0.3rem 0.6rem rgba(0, 4, 8, 0.25);
  width: 100%;
  text-align: left;
  font-size: 12px;
}
.pictureButton {
  background: none;
  border: none;
  box-shadow: none;
  color: rgba(0, 0, 0, 0.847);
  font-weight: 100;
  font-size: 12px;
  padding: 0;
}

.pictureWrapper {
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 5px;
}

.fileUploadWrapper {
  display: flex;
  justify-content: space-between;
}
</style>
